import { AnimatePresence } from 'framer-motion';
import { OurWhy } from './OurWhy';
import { OurTeam } from './OurTeam';
import { ReachOut } from './ReachOut';
import { AboutOath } from './AboutOath';
import { OurImpact } from './OurImpact';
import { Quote } from 'components/LottieElements/Quote';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';

export const AboutScreen = () => {
  return (
    <HeaderAndFooterLayout
      footerVisible={true}
      footerShowSupportCta={true}
      headerVisible={true}
      isLoading={false}
      hasIssues={true}
    >
      <AnimatePresence>
        <OurWhy />
        <AboutOath />
        <OurImpact />
        <OurTeam />
        <Quote
          text="“Our comprehensive strategy where we optimize for the marginal impact of every dollar really resonates... A majority of donors are interested in the strategic value of the seat, rather than the personality.”"
          name="Brian Derrick"
          role="Co-Founder and CEO"
        />
        <ReachOut />
      </AnimatePresence>
    </HeaderAndFooterLayout>
  );
};
